import { useRouter, useRoute } from 'vue-router'
import { computed } from 'vue'
import type { NavigationConfig } from '@el-plus/utils'
import * as qs from 'qs'
export type PageMode = 'add' | 'edit' | 'browse'

export interface Config {
  // mode变化时调用
  onModeChange?: (mode: PageMode) => void
}

export const useNavigation = (config: Config = {}) => {
  const { onModeChange } = config
  const router = useRouter()
  const route = useRoute()
  /**
   *  打开saas窗口
   * @param id  菜单id
   * @param name  路由模块name, 适用于内部跳转
   * @param title  菜单名称,适用于传外部url跳转
   * @param url  菜单url
   * @param query  url参数
   */
  const $goto = (r: NavigationConfig) => {
    const item: NavigationConfig = {
      id: Date.now(),
      name: '',
      url: '',
    }
    const openTab = window.parent.openMenuSelect

    if (r.url) {
      item.url = r.url
      item.name = r.name
      if (openTab) {
        openTab(item)
      } else {
        window.open(item.url)
      }
      return
    }
    const routes = router.getRoutes() || []

    const projectRootPath = window.location.pathname

    const findRoute = (routes, distRoute) => {
      let queen = [...routes]

      while (queen.length) {
        const first = queen.shift()
        if (first.children) {
          queen = queen.concat(first.children)
        }

        if (first.name == distRoute.name) {
          return first
        }
      }
    }
    const route = findRoute(routes, r)

    if (route) {
      item.id = r.id || item.id

      item.name =
        r.title ||
        (window.$hxt ? window.$hxt(route.meta.title) : route.meta.title)

      item.url = `${projectRootPath}#${route.path}?${qs.stringify(r.query, { encode: false })}`

      if (openTab) {
        openTab(item)
      } else {
        router.push(r)
      }
    } else {
      console.error('没有找到对应的路由')
    }
  }

  const $closeTag = () => {
    if (!window.parent.selectedRouterTags) {
      return
    }
    const currentRouterTagIndex = window.parent.currentRouterTagIndex!
    const preIndex = window.parent.currentRouterTagIndex! - 1
    const currentTag = window.parent.selectedRouterTags[currentRouterTagIndex]
    const preTag = window.parent.selectedRouterTags[preIndex]
    window.parent?.closeTag?.(currentTag)
    window.parent?.openMenuSelect?.(preTag)
  }
  const mode = computed(() => {
    return route.query.mode as PageMode
  })
  const isBrowse = computed(() => mode.value === 'browse')
  const isEdit = computed(() => mode.value === 'edit')
  const isAdd = computed(() => mode.value === 'add')
  // 修改mode
  const setMode = (newMode: PageMode, callBack?: (mode: PageMode) => void) => {
    router.replace({
      query: {
        ...route.query,
        mode: newMode,
      },
    })
    if (callBack) {
      callBack(newMode)
    } else {
      onModeChange?.(newMode)
    }
  }
  return {
    $goto,
    $closeTag,
    mode,
    isBrowse,
    isEdit,
    isAdd,
    setMode,
  }
}
